import { styled } from 'styled-components';

import { theme } from '@/shared/theme';

export const StyledOrderPageWrapper = styled.section`
    background-color: transparent;
`;

export const StyledOrderEmptyBlockWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 32px;

    div {
        text-align: center;
    }

    .icon-block {
        margin-bottom: 32px;
    }

    .title {
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 120%;
        color: ${theme.color.dark};
        margin-bottom: 10px;
    }

    .link-block {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 120%;
        width: 295px;
        margin-bottom: 25px;
        color: ${theme.color.dark};

        a {
            color: ${theme.color.primary};
        }
    }

    .btn-block {
        display: flex;
        justify-content: center;
    }
`;
